import React from 'react'
import { usePayPalButton } from 'modules/payment'

import { Icon } from 'components/dataDisplay'

import ExpressCheckoutButton from '../ExpressCheckoutButton/ExpressCheckoutButton'


const PayPalButton: React.FunctionComponent = () => {
  const { submitPayPal, isProcessing } = usePayPalButton()

  return (
    <ExpressCheckoutButton
      disabled={isProcessing}
      onClick={submitPayPal}
      data-testid="paypalButton"
    >
      <Icon name="other/paypal" />
    </ExpressCheckoutButton>
  )
}


export default PayPalButton
